import { IApplicationState } from '../../types/redux';
import { getBuilder } from '../newbuilding';

export const getBuilderChatEnabled = (state: IApplicationState): boolean => {
  const builder = getBuilder(state);

  return builder.chat.isEnabled;
};
